var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBorderCornerRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 83,
  height: 101,
  fill: "none",
  viewBox: "0 0 83 101"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M.794 2.33h79.694v98.275"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 82.148,
  x2: 0.794,
  y1: 50.584,
  y2: 50.584,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgBorderCornerRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MyIgaGVpZ2h0PSIxMDEiIHZpZXdCb3g9IjAgMCA4MyAxMDEiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGQ9Ik0wLjc5NDE4OSAyLjMyOTgzSDgwLjQ4ODNWMTAwLjYwNSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfNV8xOTI0KSIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl81XzE5MjQiIHgxPSI4Mi4xNDgiIHkxPSI1MC41ODM5IiB4Mj0iMC43OTQxODkiIHkyPSI1MC41ODM5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMyNkYwMjgiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDExRjIxIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+";